import { gql } from '@apollo/client';

export const GET_USER_PROFILE = gql`
  query GetUserProfile($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      birthDate
      email
      phoneNumber
      profilePicture
      averageRating
      reviewCount
      notificationPreferences {
        accountActivitiesEmail
        accountActivitiesPush
        accountActivitiesSms
        recommendationsEmail
        recommendationsPush
        offersUpdatesEmail
        offersUpdatesPush
      }
      __typename
    }
  }
`;

export const GET_PUBLIC_USER_PROFILE = gql`
  query GetPublicUserProfile($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      profilePicture
      averageRating
      reviewCount
      __typename
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      firstName
      lastName
      birthDate
      email
      phoneNumber
      profilePicture
      notificationPreferences {
        accountActivitiesEmail
        accountActivitiesPush
        accountActivitiesSms
        recommendationsEmail
        recommendationsPush
        offersUpdatesEmail
        offersUpdatesPush
      }
      __typename
    }
  }
`;